import React, { createContext, useContext, useMemo, useState } from 'react';

export type Product = 'resume' | 'site-assistant' | 'bot-canvas';

type ProductContextValue = {
  product: Product | null;
  setProduct: (p: Product | null) => void;
  isProduct: (p: Product) => boolean;
};

const ProductContext = createContext<ProductContextValue | undefined>(undefined);

export const ProductProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [product, setProduct] = useState<Product | null>(null);

  const value = useMemo(
    () => ({
      product,
      setProduct,
      isProduct: (p: Product) => product === p,
    }),
    [product]
  );

  return <ProductContext.Provider value={value}>{children}</ProductContext.Provider>;
};

export function useProduct() {
  const ctx = useContext(ProductContext);
  if (!ctx) throw new Error('useProduct must be used within <ProductProvider>');
  return ctx;
}
